const Paths = {
  home: "/",
};

export default Paths;
